import React from 'react';
import { Grid, Typography } from '@mui/material';

const LabelValue = ({ label, value, stacked = false, highlight = false }) => {
  return (
    <div style={styles.container(stacked)}>
      {stacked ? (
        <>
          <Typography
            component="span"
            sx={{
              fontSize: '14px',
              marginBottom: '4px',
              color: '#344054',
              fontWeight: 600,
            }}
          >
            {label}
          </Typography>
          <Typography component="span" sx={{ fontSize: '14px' }}>
            {value}
          </Typography>
        </>
      ) : (
        <Grid container>
          <Grid 
            item 
            xs={6} 
            sx={{
              ...styles.label, 
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'ellipsis'
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: '14px',
                color: '#344054',
                fontWeight: 600,
                marginBottom: '0 !important'
              }}
            >
              {label}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={styles.value}>
            <Typography component="span" sx={{ fontSize: '14px' }}>
              {value}
            </Typography>
          </Grid>
        </Grid>
      )}
      {highlight && <div style={styles.highlightIndicator(stacked)}></div>} {/* Highlight indicator */}
    </div>
  );
};

const styles = {
  container: (stacked) => ({
    display: 'flex',
    flexDirection: stacked ? 'column' : 'row',
    borderBottom: '1px solid #EAECF0',
    padding: '8px 0',
    position: 'relative', // Added for positioning highlight indicator
  }),
  label: {
    paddingRight: '8px', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
  },
  value: {
    // Optional: Add specific styles for value if needed
  },
  highlightIndicator: (stacked) => ({
    position: 'absolute',
    left: stacked ? '0' : '100%', // Adjust left position based on layout
    top: '50%',
    transform: 'translateY(-50%)',
    width: '12px', // Increased size
    height: '12px', // Increased size
    borderRadius: '50%', // Makes it a dot
    backgroundColor: '#D32F2F', // Color for the highlight
    boxShadow: '0 0 0 4px white', // Increased shadow for better contrast
  }),
};

export default LabelValue;